import _ from "lodash";
import { Mapper } from "../domain/mappers/Mapper";
import { UserDTO } from "../domain/models/dto/UserDTO";
import { User } from "../domain/models/User";
import UserModel from "../models/UserModel";
import { RoleMapper } from "./RoleMapper";
import { SimpleMapper } from "./SimpleMapper";

class UserMapper extends SimpleMapper<User, UserDTO> {
    protected entityConstructor = UserModel;

    protected toDTOFields: string[] = [
        "id",
        "isActive",
        "firstName",
        "lastName",
        "middleName",
        "phone",
        "position",
        "description",
        "email",
        "files",
    ];

    protected fromDTOFields: string[] = [
        "id",
        "firstName",
        "lastName",
        "middleName",
        "roleId",
        "phone",
        "email",
        "position",
        "description",
        "rating",
        "role",
        "files",
    ];

    toDTO(model: User): UserDTO {
        if (!model) {
            return null;
        }
        const result = super.toDTO(model);
        const roleMapper = new RoleMapper();

        result.role = !_.isEmpty(model.role)
            ? roleMapper.toDTO(model.role)
            : null;
        return result;
    }

    fromDTO(dto: UserDTO): User {
        if (!dto) {
            return null;
        }
        const result = super.fromDTO(dto);
        const roleMapper = new RoleMapper();

        result.role = !_.isEmpty(dto.role)
            ? roleMapper.fromDTO(dto.role)
            : null;
        return result;
    }
}

export default function userMapperFactory(): Mapper<User, UserDTO> {
    return new UserMapper();
}
